import { TableComponentProps } from '../models/table-models';
import React, { Suspense, useMemo, useState } from 'react';
import {Form, Spinner} from 'react-bootstrap';
import { InventoryInner } from './stock/InventoryInner';
import {
    useGetAllQuantities,
    useGetUserInventory,
    useGetWarehouses,
} from '../utils/warehouses-hooks';
import {resourceCache} from 'use-async-resource';
import {useTranslation} from "react-i18next";
import { useTableData } from '../utils/data-hooks';
import { InventoryContent } from '../models/warehouse-models';

export const Inventory = ({ filter, pagination }: TableComponentProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [forSale, setForSale] = useState(false);
    const inventoryFilter = useMemo(() => ({ ...filter, ...(forSale ? { forSale } : {}) }), [filter, forSale]);

    const [getInventory, fetchNewInventory] = useTableData<InventoryContent[]>(useGetUserInventory, pagination, inventoryFilter);

    const refetchInventoryHook = async () => {
        resourceCache(useGetWarehouses).clear();
        resourceCache(useGetUserInventory).clear();
        resourceCache(useGetAllQuantities).clear();

        await fetchNewInventory({
            'pager.page': pagination.currentPage,
            'pager.itemsPerPage': pagination.pageSize,
            pagination,
            filter: inventoryFilter,
        });
    };

    const changeOnlyForSell = (event: React.ChangeEvent<HTMLInputElement>) => {
        pagination.setCurrentPage(1);
        setForSale(event.target.checked);
    };

    return (
        <>
            <Suspense fallback={<Spinner animation='border' />}>
                <div className='my-3'>
                    <Form.Label htmlFor='isForSale' className='mx-2 mb-0'>
                        {t('showForSale')}
                    </Form.Label>
                    <Form.Check.Input
                        id='isForSale'
                        type='checkbox'
                        className='my-0 mx-1'
                        onChange={changeOnlyForSell}
                        defaultChecked={false}
                    />
                </div>
                <InventoryInner
                    getEntities={getInventory}
                    pagination={pagination}
                    refetchEntitiesHook={refetchInventoryHook}
                />
            </Suspense>
        </>
    );
};
